<template>
  <div>
    <div class="toolbar">
      <div class="tgroup">
        <span class="tlabel">вид</span>
        <button type="button" class="tgl" :aria-pressed="String(view === 'matrix')" data-help="вид/матрица"
                @click="$emit('update:view', 'matrix')">матрица</button>
        <button type="button" class="tgl" :aria-pressed="String(view === 'strips')" data-help="вид/распределение"
                @click="$emit('update:view', 'strips')">распределение</button>
      </div>

      <div class="tgroup">
        <span class="tlabel">метрика</span>
        <button type="button" class="tgl" :aria-pressed="String(metric === 'cum')"
                @click="$emit('update:metric', 'cum')">кумулятивный отток</button>
        <button type="button" class="tgl" :aria-pressed="String(metric === 'plain')"
                @click="$emit('update:metric', 'plain')">отток</button>
      </div>

      <div class="tgroup">
        <span class="tlabel">форма</span>
        <button type="button" class="tgl" :aria-pressed="String(form === 'percent')"
                :disabled="view === 'strips'"
                @click="$emit('update:form', 'percent')">проценты</button>
        <button type="button" class="tgl" :aria-pressed="String(form === 'value')"
                :disabled="view === 'strips'"
                @click="$emit('update:form', 'value')">значения</button>
      </div>

      <div class="tgroup">
        <button type="button" class="tgl" :aria-pressed="String(showValues)" data-help="вид/значения"
                :disabled="view === 'strips'"
                @click="$emit('update:showValues', !showValues)">цифры в ячейках</button>
      </div>

      <div class="tgroup">
        <span class="tlabel">у слова</span>
        <label class="chk" title="Сессий со словом за период — в шапке помечены буквой s">
          <input type="checkbox" :checked="showSes" :disabled="view === 'strips'"
                 @change="$emit('update:showSes', $event.target.checked)"> сессии <b>s</b>
        </label>
        <label class="chk" title="Конверсий по фразам со словом — в шапке помечены буквой c">
          <input type="checkbox" :checked="showConv" :disabled="view === 'strips'"
                 @change="$emit('update:showConv', $event.target.checked)"> конверсии <b>c</b>
        </label>
      </div>

      <div class="tgroup">
        <span class="tlabel">сортировка</span>
        <select class="btn ins-sort" data-help="сортировка/список" :value="sortValue" :disabled="view === 'strips'" @change="onSort">
          <option value="ses">по сессиям за период</option>
          <option value="conv">по конверсиям</option>
          <option value="alpha">по алфавиту</option>
          <option value="total">по итогу</option>
          <option v-if="typeof sort.key === 'number'" :value="'block:' + sort.key">
            по блоку «{{ blocks[sort.key] }}»
          </option>
        </select>
        <button type="button" class="btn" :disabled="view === 'strips'" data-help="сортировка/направление"
                :aria-label="sort.dir === 'desc' ? 'по убыванию' : 'по возрастанию'"
                @click="$emit('update:sort', { key: sort.key, dir: sort.dir === 'desc' ? 'asc' : 'desc' })">
          {{ sort.dir === 'desc' ? '↓' : '↑' }}
        </button>
      </div>

      <div class="tgroup">
        <span class="tlabel">медиана</span>
        <button type="button" class="tgl" :aria-pressed="String(marker)" data-help="медиана/маркер"
                :disabled="view === 'strips' || delta"
                @click="$emit('update:marker', !marker)">маркер</button>
        <button type="button" class="tgl" :aria-pressed="String(dev)" data-help="медиана/отклонения"
                @click="$emit('update:dev', !dev)">отклонения</button>
      </div>

      <div class="tgroup">
        <div class="legend">
          <span class="item" v-for="(item, i) in legend" :key="i">
            <span class="swatch"
                  :style="{ background: item.color, borderRadius: item.round ? '50%' : null }"></span>
            <span class="lab">{{ item.label }}</span>
          </span>
        </div>
      </div>
    </div>

    <div class="toolbar">
      <div class="tgroup">
        <span class="tlabel">инструменты</span>
        <button type="button" class="tgl" :aria-pressed="String(feed)" data-help="инстр/инсайты"
                @click="$emit('update:feed', !feed)">лента инсайтов</button>
        <button type="button" class="tgl" :aria-pressed="String(delta)" data-help="инстр/прирост"
                @click="$emit('update:delta', !delta)">прирост Δ</button>
        <button type="button" class="tgl" :aria-pressed="String(iqr)" data-help="инстр/квартили"
                @click="$emit('update:iqr', !iqr)">квартили</button>
        <button type="button" class="tgl" :aria-pressed="String(brush)" data-help="инстр/выделение"
                @click="$emit('update:brush', !brush)">выделение</button>
        <button type="button" class="tgl" :aria-pressed="String(cmp)" data-help="инстр/сравнение"
                @click="$emit('update:cmp', !cmp)">сравнение</button>
      </div>
      <div class="tgroup">
        <span class="tlabel">сегмент</span>
        <button type="button" class="tgl" :aria-pressed="String(segMode)" data-help="сегмент/собрать"
                @click="$emit('update:segMode', !segMode)">собрать</button>
      </div>
      <!-- Отметки нужны, только когда есть что отмечать: пустая группа зря занимала бы
           место и могла перенести панель на вторую строку. -->
      <div class="tgroup" v-if="hasSegments">
        <span class="tlabel">отметка сегмента</span>
        <button type="button" class="tgl" :aria-pressed="String(segMarks.lift)" data-help="сегмент/приподнят"
                @click="$emit('update:segMarks', { ...segMarks, lift: !segMarks.lift })">приподнят</button>
        <button type="button" class="tgl" :aria-pressed="String(segMarks.out)" data-help="сегмент/выдвинут"
                @click="$emit('update:segMarks', { ...segMarks, out: !segMarks.out })">выдвинут</button>
      </div>
      <div class="tgroup">
        <span class="tlabel">столбец</span>
        <!-- В распределении слои заперты, но остаются нажатыми, как в прототипе (8033): вернёшься
             в матрицу — они снова работают, и кнопка не должна врать об обратном. -->
        <button type="button" class="tgl" :aria-pressed="String(layers)" data-help="столбец/слои"
                :disabled="view === 'strips'"
                @click="$emit('update:layers', !layers)">слои</button>
      </div>
      <div class="tgroup" v-if="hint">
        <span class="tlabel">{{ hint }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightsToolbar',
  props: {
    view: { type: String, required: true },
    metric: { type: String, required: true },
    form: { type: String, required: true },
    showValues: { type: Boolean, required: true },
    showSes: { type: Boolean, required: true },
    showConv: { type: Boolean, required: true },
    sort: { type: Object, required: true },
    blocks: { type: Array, required: true },
    marker: { type: Boolean, required: true },
    dev: { type: Boolean, required: true },
    feed: { type: Boolean, required: true },
    delta: { type: Boolean, required: true },
    iqr: { type: Boolean, required: true },
    brush: { type: Boolean, required: true },
    cmp: { type: Boolean, required: true },
    bounds: { type: Array, required: true },
    hint: { type: String, default: '' },
    segMode: { type: Boolean, default: false },
    hasSegments: { type: Boolean, default: false },
    segMarks: { type: Object, default: () => ({ lift: true, out: false }) },
    layers: { type: Boolean, default: true },
  },
  emits: ['update:view', 'update:metric', 'update:form', 'update:showValues',
          'update:showSes', 'update:showConv',
          'update:marker', 'update:dev', 'update:feed', 'update:delta',
          'update:iqr', 'update:brush', 'update:cmp', 'update:sort',
          'update:segMode', 'update:segMarks', 'update:layers'],
  computed: {
    sortValue() {
      return typeof this.sort.key === 'number' ? 'block:' + this.sort.key : this.sort.key;
    },
    legend() {
      if (this.dev) {
        return [
          { color: 'var(--cell-100)', label: 'сильно ниже' },
          { color: 'var(--cell-60)', label: 'ниже' },
          { color: 'var(--cell-0)', label: '≈ медиана' },
          { color: 'var(--cell-20)', label: 'выше' },
          { color: 'var(--cell-40)', label: 'сильно выше' },
        ];
      }
      if (this.view === 'strips') {
        return [
          { color: 'var(--seq-60)', label: 'слово', round: true },
          { color: 'var(--seq-100)', label: 'выбранное', round: true },
          { color: 'var(--text-primary)', label: 'медиана блока' },
        ];
      }
      // Для простого оттока шкала растянута до максимума по матрице, а он
      // бывает в единицы процентов. На целых числах подписи схлопнулись бы
      // в «1–1» и «≤ 0», поэтому точность подбирается по верхней границе.
      const max = this.bounds[this.bounds.length - 1];
      const digits = max >= 0.05 ? 0 : (max >= 0.005 ? 1 : 2);
      const pct = v => (v * 100).toFixed(digits);
      const out = [{ color: 'var(--seq-0)', label: '0' }];
      for (let i = 1; i < this.bounds.length; i++) {
        const to = pct(this.bounds[i]);
        out.push({
          color: 'var(--seq-' + (i * 20) + ')',
          label: (i === 1 ? '≤ ' + to : pct(this.bounds[i - 1]) + '–' + to)
            + (i === this.bounds.length - 1 ? ' %' : ''),
        });
      }
      return out;
    },
  },
  methods: {
    onSort(event) {
      const value = event.target.value;
      const key = value.startsWith('block:') ? Number(value.slice(6)) : value;
      this.$emit('update:sort', { key: key, dir: 'desc' });
    },
  },
};
</script>

<style scoped>
.ins-sort { width: 210px; }
.chk {
  display: flex; align-items: center; gap: 5px;
  font-size: 12.5px; color: var(--text-secondary); cursor: pointer; white-space: nowrap;
}
.chk input { margin: 0; cursor: pointer; }
.chk:has(input:disabled) { opacity: .35; cursor: default; }
/* Та же буква, что и в шапке матрицы: подпись у слова короткая, и связь
   «галочка → буква» иначе нечем показать. */
.chk b { color: var(--text-muted); font-weight: 650; }
</style>
